import Vue from 'vue'
import VueI18n from 'vue-i18n'
// elementui 多语言
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhtwLocale from 'element-ui/lib/locale/lang/zh-TW'
import koLocale from 'element-ui/lib/locale/lang/ko'
import jpLocale from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import { getLocalLanguage } from './utils/language'
// 本地多语言包
import enUs from './locales/en-us.json'
import zhCn from './locales/zh-cn.json'
import zhTw from './locales/zh-tw.json'
import jaJp from './locales/ja-jp.json'
import koKr from './locales/ko-kr.json'

Vue.use(VueI18n)

const i18n = new VueI18n({
  // locale: language || 'en-us',
  // fallbackLocale: language || 'en-us',
  locale: import.meta.env.VITE_I18N_LOCALE || 'en',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  messages: {
    'en-us': enUs,
    'zh-cn': zhCn,
    'zh-tw': zhTw,
    'ja-jp': jaJp,
    'ko-kr': koKr
  }
})

/** ************配置语言**************** */
export const setGlobalLanguage = (store, lang) => {
  const support = {
    default: 'en-us',
    zhcn: 'zh-cn',
    zhtw: 'zh-tw',
    zhsg: 'zh-tw',
    zhhk: 'zh-tw',
    enus: 'en-us',
    jajp: 'ja-jp',
    kokr: 'ko-kr',
    zh: 'zh-cn',
    en: 'en-us',
    ja: 'ja-jp',
    ko: 'ko-kr',
    zhhans: 'zh-cn',
    zhhant: 'zh-tw'
  }

  let language = lang || getLocalLanguage()
  language = language.replace('-', '')
  // 兼容类似ja-cn对应日语这种情况
  // language = support[language] || support.default
  const prefix = language.substr(0, 2)
  language = support[language] || support[prefix] || support.default
  i18n.locale = language
  store.commit('user/saveLanguage', language)

  switch (language) {
    case 'zh-cn':
      locale.use(zhLocale)
      break
    case 'zh-tw':
      locale.use(zhtwLocale)
      break
    case 'ko-kr':
      locale.use(koLocale)
      break
    case 'ja-jp':
      locale.use(jpLocale)
      break
    default:
      // 防止language 未设置上时，设置默认英文
      i18n.locale = 'en-us'
      store.commit('user/saveLanguage', 'en-us')
      locale.use(enLocale)
  }
}

export default i18n

if (!__BUILD__) {
  if (import.meta.hot) {
    import.meta.hot.accept(
      [
        './locales/en-us.json',
        './locales/zh-cn.json',
        './locales/zh-tw.json',
        './locales/ja-jp.json',
        './locales/ko-kr.json'
      ],
      () => {
        i18n.setLocaleMessage('en-us', enUs)
        i18n.setLocaleMessage('zh-cn', zhCn)
        i18n.setLocaleMessage('zh-tw', zhTw)
        i18n.setLocaleMessage('ja-jp', jaJp)
        i18n.setLocaleMessage('ko-kr', koKr)
      }
    )
  }
}
